<template>
  <span class="badge" :class="'badge--' + tone">{{ label }}</span>
</template>

<script>
/**
 * A status pill. `tone` is a closed list so the panel never grows a new colour
 * per page: gray, blue, cyan, amber, green, red, purple, gold.
 */
export default {
  name: "StatusBadge",
  props: {
    label: { type: String, required: true },
    tone: { type: String, default: "gray" },
  },
};
</script>

<style scoped>
.badge {
  display: inline-block;
  padding: 2px var(--s-2);
  border-radius: 999px;
  font-size: var(--t-caption);
  line-height: var(--t-caption-lh);
  font-weight: 600;
  white-space: nowrap;
  background: var(--bg-tertiary);
  color: var(--text-secondary);
}
.badge--red { background: var(--danger-bg); color: var(--danger); }
.badge--amber, .badge--gold { background: var(--warning-bg); color: var(--warning); }
.badge--green { background: var(--success-bg); color: var(--success); }
.badge--blue, .badge--cyan { background: var(--info-bg); color: var(--info); }
.badge--purple { background: var(--accent-primary-bg); color: var(--text-link); }
</style>
